// Fecha: 11-07-2024


import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewIngresoHacienda = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'ingresohacienda',
        name: 'Ingreso hacienda',
        component: ViewIngresoHacienda,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
